module.exports = __webpack_public_path__ + "media/images/google-logo-065d46584695ea8648a5369590774194.png";